import { ProductInfoServer } from '../store/types';

import { productList } from './const';
import { getLocalProducts, setLocalProducts } from './localStorage';

export const adapteProducts = (res: ProductInfoServer[]) => {
  const localProducts = getLocalProducts();

  const adaptedProducts = productList.map((productName) => {
    const onlineProd = res.find((resProd) => resProd.name === productName);
    const localProduct = localProducts.find((localProd) => localProd.name === productName);
    return ({
      ...(onlineProd ?? localProduct ?? { name: productName, price: 1, id: productName }),
      isOnline: onlineProd !== undefined
    });
  });
  setLocalProducts(adaptedProducts);
  return (adaptedProducts);
};
